module.exports = __webpack_public_path__ + "fonts/ProximaNovaW05-Extrabold.eba4dba7.ttf";